import { Injectable }                    from '@angular/core';
import { Store }                         from '@ngrx/store';
import { RbDocument }                    from '~domain/types';
import {
  deleteDocument,
  reloadPage,
}                                        from '../../state/app.actions';
import { selectDeleteDocumentIsLoading } from '../../state/app.selectors';

@Injectable({
  providedIn: 'root',
})
export class DeleteDocumentService {
  deleteDocumentIsLoading$ = this.store.select(selectDeleteDocumentIsLoading);

  constructor(private readonly store: Store) {
  }

  deleteDocuments(documentIds: string[], queuedDocuments?: RbDocument[]) {
    this.store.dispatch(deleteDocument({ documentIds, queuedDocuments }));
  }

  reloadPage() {
    this.store.dispatch(reloadPage());
  }
}
